import React, { Component } from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";

import Paper from "@material-ui/core/Paper";
import Heading from "../../components/Heading";

import BookingRequests from "../../components/booking/BookingRequests";
import BookingAccepted from "../../components/booking/BookingAccepted";
import BookingCompleted from "../../components/booking/BookingCompleted";
import BookingCancelled from "../../components/booking/BookingCancelled";

import Loading from "../../components/loadingSpinner/Loading";

import { Tabs, Tab, Badge, Grid, Hidden, TextField, MenuItem, AppBar } from "@material-ui/core";
import { BookingStatusType } from "../../types/enum";
import AgentFilter from "../../components/filters/AgentFilter";

import "./AgentGig.css";
import BookingDrafts from "../../components/booking/BookingDrafts";
import BookingAll from "../../components/booking/BookingAll";

const styles = theme => ({
    root: {
        width: "90%"
    },
    backButton: {
        marginRight: theme.spacing.unit
    },
    instructions: {
        marginTop: theme.spacing.unit,
        marginBottom: theme.spacing.unit
    }
});

@inject("templateStore", "profileStore", "bookingRequestStore", "reportStore")
@withRouter
@observer
class AgentGig extends Component {
    state = {
        tabValue: 0,
        isLoading: true
    };

    constructor(props) {
        super(props);
        this.props.bookingRequestStore.resetRequestsUpcomingCompleted();
        this.props.reportStore.resetFilterData();
    }

    componentWillUnmount() {
        this.props.reportStore.resetFilterData();
    }

    loadGigs = filterData => {
        const {
            currentProfile
        } = this.props.profileStore;
        
        this.props.bookingRequestStore.showLoadingState();

        if(filterData){
            this.props.reportStore.setVenueFilter(filterData.venue);
            this.props.reportStore.setActFilter(filterData.act);

            this.props.reportStore.setStartDate(filterData.startDate);
            this.props.reportStore.setEndDate(filterData.endDate);
            this.props.reportStore.setBookingType(filterData.bookingType);
            this.props.reportStore.setDayOfWeekFilter(filterData.dayOfWeek);
        }

        this.props.bookingRequestStore.resetRequestGigs()
            
        Promise.all([
            this.props.bookingRequestStore.loadGigsRequests(currentProfile?.id,1),
        ]).then(() => {
          
            this.props.bookingRequestStore.hideLoadingState();
        });
        if(this.state.tabValue == 3){
            this.props.bookingRequestStore.resetCompletedGigs()
            Promise.all([
                this.props.bookingRequestStore.getCompletedGigs(currentProfile?.id,1),
            ]).then(() => {
               
                this.props.bookingRequestStore.hideLoadingState();
            });
        }else if(this.state.tabValue == 0 || this.state.tabValue == 1){
           
        }else if(this.state.tabValue == 2){
            this.props.bookingRequestStore.resetUpcomingGigs()
            Promise.all([
                this.props.bookingRequestStore.loadUpcomingGigs(currentProfile?.id,1),
            ]).then(() => {
               
                this.props.bookingRequestStore.hideLoadingState();
            });
        }else if(this.state.tabValue == 4){
            this.props.bookingRequestStore.resetCancelledGigs()
            Promise.all([
                this.props.bookingRequestStore.getCancelledGigs(currentProfile?.id,1)
            ]).then(() => {
               
                this.props.bookingRequestStore.hideLoadingState();
            });
        } else if(this.state.tabValue == 5){
            this.props.bookingRequestStore.resetAllGigs()
            Promise.all([
                this.props.bookingRequestStore.loadAllGigs(currentProfile?.id,1)
            ]).then(() => {
                
                this.props.bookingRequestStore.hideLoadingState();
            });
        }
    };

    componentDidMount = () => {
        const {
            currentProfile
        } = this.props.profileStore;
        this.props.bookingRequestStore.resetRequestGigs()
        this.props.bookingRequestStore.showLoadingState();

        let initialTab = 0;
        if (this.props && this.props.match && this.props.match.params && this.props.match.params.tab) {
            const tab = this.props.match.params.tab;
            if (tab === "drafts") {
                initialTab = 0;
            } else if (tab === "request") {
                initialTab = 1;
            } else if (tab === "upcoming" || tab === "upcomingSuper") {
                initialTab = 2;
            } else if (tab === "completed") {
                initialTab = 3;
            } else if (tab === "cancelled") {
                initialTab = 4;
            } else if (tab === "all") {
                initialTab = 5;
            }
            this.setState({ tabValue: initialTab });
        }

        this.props.bookingRequestStore.loadGigsRequests(currentProfile?.id,1).then(() => {
            this.setState({
                ...this.state,
                isLoading: false
            });
            this.props.bookingRequestStore.hideLoadingState();
        });
        if (initialTab !== 0 && initialTab !== 1) {
            this.reloadGigsForCurrentTab(initialTab);
        }
    };

    handleTabChange = (event, value) => {
        switch (value) {
            case 0:
                this.props.history.replace("/agent/gig/draft");
                break;
            case 1:
                this.props.history.replace("/agent/gig/request");
                break;
            case 2:
                this.props.history.replace("/agent/gig/upcoming");
                break;
            case 3:
                this.props.history.replace("/agent/gig/completed");
                break;
            case 4:
                this.props.history.replace("/agent/gig/cancelled");
                break;
            case 5:
                this.props.history.replace("/agent/gig/all");
                break;
            default:
                this.props.history.replace("/agent/gig/draft");
                break;
        }

        this.setState({
            tabValue: value
        });
        if (value !== 0 && value !== 1) {
            this.reloadGigsForCurrentTab(value);
        }
    };

    reloadGigsForCurrentTab = (tabValue) => {
        const { currentProfile } = this.props.profileStore;
        this.props.bookingRequestStore.showLoadingState();

        if (tabValue === 0 || tabValue === 1) {
            this.props.bookingRequestStore.resetRequestGigs();
            this.props.bookingRequestStore.loadGigsRequests(currentProfile?.id, 1).then(() => {
                this.props.bookingRequestStore.hideLoadingState();
            });
        } else if (tabValue === 2) {
            this.props.bookingRequestStore.resetUpcomingGigs();
            this.props.bookingRequestStore.loadUpcomingGigs(currentProfile?.id, 1).then(() => {
                this.props.bookingRequestStore.hideLoadingState();
            });
        } else if (tabValue === 3) {
            this.props.bookingRequestStore.resetCompletedGigs();
            this.props.bookingRequestStore.getCompletedGigs(currentProfile?.id, 1).then(() => {
                this.props.bookingRequestStore.hideLoadingState();
            });
        } else if (tabValue === 4) {
            this.props.bookingRequestStore.resetCancelledGigs();
            this.props.bookingRequestStore.getCancelledGigs(currentProfile?.id, 1).then(() => {
                this.props.bookingRequestStore.hideLoadingState();
            });
        } else if (tabValue === 5) {
            this.props.bookingRequestStore.resetAllGigs();
            this.props.bookingRequestStore.loadAllGigs(currentProfile?.id, 1).then(() => {
                this.props.bookingRequestStore.hideLoadingState();
            });
        } else {
            this.props.bookingRequestStore.hideLoadingState();
        }
    };

    handleSelectChange = event => {
        switch (event.target.value) {
            case 0:
                this.props.history.replace("/agent/gig/draft");
                break;
            case 1:
                this.props.history.replace("/agent/gig/request");
                break;
            case 2:
                this.props.history.replace("/agent/gig/upcoming");
                break;
            case 3:
                this.props.history.replace("/agent/gig/completed");
                break;
            case 4:
                this.props.history.replace("/agent/gig/cancelled");
                break;
            case 5:
                this.props.history.replace("/agent/gig/all");
                break;
            default:
                this.props.history.replace("/agent/gig/draft");
                break;
        }

        this.setState({
            tabValue: event.target.value
        });
        if (event.target.value !== 0 && event.target.value !== 1) {
            this.reloadGigsForCurrentTab(event.target.value);
        }
    };

    renderTabComponent = () => {
        const { tabValue } = this.state;

        switch (tabValue) {
            case 0:
                return <BookingDrafts profileType="agent" />;
            case 1:
                return <BookingRequests profileType="agent" />;
            case 2:
                return <BookingAccepted profileType="agent" />;
            case 3:
                return <BookingCompleted profileType="agent" />;
            case 4:
                return <BookingCancelled profileType="agent" />;
            case 5:
                return <BookingAll profileType="agent" />;
            default:
                return "";
        }
    };

    renderRequestTabTitle = (title, list) => {
        var needAction = list.filter(data => data.status === BookingStatusType.Declined.ordinal);
        return list && needAction && needAction.length > 0 ? (
            <Badge color="primary" style={{ paddingRight: "16px" }} badgeContent={needAction.length}>
                {title}
            </Badge>
        ) : (
            title
        );
    };

    renderUpcomingTabTitle = (title, list) => {
        // var needAction = list.filter( data => data.status === BookingStatusType.Declined.ordinal || data.status === BookingStatusType.Resent.ordinal);
        return list && list.length > 0 ? (
            <Badge color="primary" style={{ paddingRight: "16px" }} badgeContent={list.length}>
                {title}
            </Badge>
        ) : (
            title
        );
    };

    renderTabTitleSmall = (title, list) => {
        let content = <span className="test">{list ? list.length : 0}</span>;
        return list && list.length > 0 ? (
            <Badge color="primary" classes={{ badge: "itembadge" }} badgeContent={content}>
                {title}
            </Badge>
        ) : (
            title
        );
    };

    render() {
        let { drafts, requests, newRequests, upcomings, completed, cancelled, isLoading: isLoadingGigs, filteredData, allGigs} = this.props.bookingRequestStore;
        const {isLoading} = this.state
        return (
            <div>
                <Header />
                <Sidebar />
                <MainContainer>
                    <Heading 
                        title="My Gigs"
                        secondRow={<AgentFilter isLoading={isLoading} showActFilter paginatedActFilter paginatedVenueFilter postChangeEvent={this.loadGigs} filterSection="date" />}
                    >
                        <AgentFilter isLoading={isLoading} showActFilter paginatedActFilter paginatedVenueFilter postChangeEvent={this.loadGigs} filterSection="entity" />
                    </Heading>
                    <Paper style={{ position: "relative" }} className="booking-paper-form">
                        <Loading showed={isLoadingGigs} />
                        <Hidden smDown>
                            <AppBar position="static" elevation={2} style={{ backgroundColor: "#3A3B3D" }}>
                                <Tabs 
                                    value={this.state.tabValue} 
                                    onChange={this.handleTabChange} 
                                    indicatorColor="primary" 
                                    textColor="secondary"
                                    scrollable
                                    scrollButtons="off"
                                    classes={{
                                        root: "tabs-root",
                                        indicator: "tabs-indicator"
                                    }}
                                >
                                    <Tab label={this.renderUpcomingTabTitle("Draft Bookings", filteredData.drafts ? filteredData.drafts : drafts)} classes={{ selected: "tab-selected" }} />
                                    <Tab label={this.renderUpcomingTabTitle("Booking Requests", filteredData.requests ? filteredData.requests : newRequests)} classes={{ selected: "tab-selected" }} />
                                    <Tab label={this.renderUpcomingTabTitle("Upcoming Gigs", filteredData.upcomings ? filteredData.upcomings : upcomings)} classes={{ selected: "tab-selected" }} />
                                    <Tab label={this.renderUpcomingTabTitle("Completed Gigs", filteredData.completed ? filteredData.completed : completed)} classes={{ selected: "tab-selected" }} />
                                    <Tab label={this.renderUpcomingTabTitle("Cancelled Gigs", filteredData.cancelled ? filteredData.cancelled : cancelled)} classes={{ selected: "tab-selected" }} />
                                    <Tab label={this.renderUpcomingTabTitle("All Gigs", filteredData.allGigs ? filteredData.allGigs : allGigs)} classes={{ selected: "tab-selected" }} />
                                </Tabs>
                            </AppBar>
                        </Hidden>
                        <Hidden mdUp>
                            <div style={{ padding: 8 }}>
                                <TextField select value={this.state.tabValue} onChange={this.handleSelectChange} textColor="primary" fullWidth>
                                    <MenuItem key={0} value={0}>
                                        {this.renderTabTitleSmall("Draft Bookings", drafts)}
                                    </MenuItem>
                                    <MenuItem key={1} value={1}>
                                        {this.renderTabTitleSmall("Booking Requests", newRequests)}
                                    </MenuItem>
                                    <MenuItem key={2} value={2}>
                                        {this.renderTabTitleSmall("Upcoming Gigs", upcomings)}
                                    </MenuItem>
                                    <MenuItem key={3} value={3}>
                                        {this.renderTabTitleSmall("Completed Gigs", completed)}
                                    </MenuItem>
                                    <MenuItem key={4} value={4}>
                                        {this.renderTabTitleSmall("Cancelled Gigs", cancelled)}
                                    </MenuItem>
                                    <MenuItem key={5} value={5}>
                                        {this.renderTabTitleSmall("All Gigs", allGigs)}
                                    </MenuItem>
                                </TextField>
                            </div>
                        </Hidden>
                        <Grid container spacing={16}>
                            <Grid item xs={12}>
                                <div style={{ padding: 16 }}>{this.renderTabComponent()}</div>
                            </Grid>
                        </Grid>
                    </Paper>
                </MainContainer>
            </div>
        );
    }
}

AgentGig.propTypes = {
    classes: PropTypes.object
};
export default withStyles(styles)(AgentGig);
